import type { TaskTrackerItemDto } from '../../api/modules/projects/task-tracker';

export interface TeamMemberForAssignment {
  employee_id: string;
  employee_name?: string;
}

/**
 * Assigns tasks to employees based on team composition using round-robin.
 * Only considers unassigned tasks by default so existing assignments are preserved.
 * Returns a list of { itemId, assigned_employee_id } to be applied via updateItem.
 */
export function assignTasksByTeamComposition(
  teamMembers: TeamMemberForAssignment[],
  items: TaskTrackerItemDto[],
  options?: { onlyUnassigned?: boolean }
): { itemId: string; assigned_employee_id: string }[] {
  const onlyUnassigned = options?.onlyUnassigned !== false;
  const toAssign = onlyUnassigned
    ? items.filter((i) => !i.assigned_employee_id)
    : [...items];
  if (teamMembers.length === 0 || toAssign.length === 0) return [];
  const result: { itemId: string; assigned_employee_id: string }[] = [];
  toAssign.forEach((item, idx) => {
    const member = teamMembers[idx % teamMembers.length];
    result.push({ itemId: item.id, assigned_employee_id: member.employee_id });
  });
  return result;
}
